import { Component } from '@theme/component';

const REVEALED_CLASS = 'motion-reveal--visible';

/**
 * A custom element that fades/lifts its children into view the first time
 * they scroll into the viewport. No-ops entirely when the visitor has
 * requested reduced motion.
 *
 * Usage: wrap any block of markup in <motion-reveal> (optionally with a
 * data-delay="150" attribute in milliseconds for staggered entrances).
 */
class MotionRevealComponent extends Component {
  connectedCallback() {
    super.connectedCallback();

    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      this.classList.add(REVEALED_CLASS);
      return;
    }

    const delay = Number(this.dataset.delay) || 0;

    this.#observer = new IntersectionObserver(
      (entries) => {
        for (const entry of entries) {
          if (!entry.isIntersecting) continue;

          window.setTimeout(() => this.classList.add(REVEALED_CLASS), delay);
          this.#observer?.disconnect();
          break;
        }
      },
      { threshold: 0.15 }
    );

    this.#observer.observe(this);
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    this.#observer?.disconnect();
  }

  /** @type {IntersectionObserver | null} */
  #observer = null;
}

if (!customElements.get('motion-reveal')) {
  customElements.define('motion-reveal', MotionRevealComponent);
}
